module.exports = __webpack_public_path__ + "img/material_is_null.2d5a6330.png";